// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
* {
  box-sizing: border-box;
}

/* body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  justify-content: center;
  align-content: center;
  height: 100vh;
  width: 100vw;
} */

form {
  width: 30vw;
  min-width: 500px;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  padding: 40px;
}

.hidden {
  display: none;
}

#payment-message {
  color: rgb(149, 40, 0);
  font-size: 16px;
  line-height: 20px;
  padding-top: 12px;
  text-align: center;
}

#payment-element {
  margin-bottom: 24px;
}

/* Buttons and links */

/*button {
  background: #6e5eff;
  font-family: Roboto, "Helvetica Neue", sans-serif;
  color: #ffffff;
  border-radius: 5px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}
button:hover {
  filter: contrast(115%);
}
button:disabled {
  opacity: 0.5;
  cursor: default;
}*/

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}
.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  transform: translateZ(0);
}
.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}
.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #5469d4;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  transform-origin: 10.4px 10.2px;
  animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #5469d4;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  transform-origin: 0px 10.2px;
  animation: loading 2s infinite ease;
}

/*WC 05132022 */
.payment-sec {
  display: flex;
  margin-top: 5px;
  justify-content: center;
  align-items: center;
}

.selected-plan-sec {
  display: flex;
  margin-top: 5px;
  justify-content: center;
  align-items: center;
}

.selected-plan {
  /*display: flex;*/
  margin-top: 100px;
  width: 30vw;
  min-width: 500px;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
  0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  padding: 40px;
  font-size: 15px;
  font-weight: 500;
  /*background-color: #6e5eff;*/
  background-color: #f7fbff;
  color: rgb(0 0 0 / 70%);
}

.selected-plan-sec .selected-plan p {
  text-align: center;
  font-weight: 500;
}

/*WC 05132022 */

/* WC 07202022 */
.modal-body p{
display: inline-block;
font-size: 14px;
font-weight: normal;
margin-left: 10px;

}

.modal-body ul{
display: inline-block;
font-size: 14px;
font-weight: normal;
margin-left: 10px;

}

/* WC 07202022*/
@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 600px) {
  form {
    width: 80vw;
    min-width: initial;
  }
}


/********************************************/

.shopping-cart{
  padding-bottom: 50px;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.shopping-cart.dark{
  background-color: #f6f6f6;
}

.shopping-cart .content{
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.075);
  background-color: white;
}

.shopping-cart .block-heading{
    /*padding-top: 50px;*/
    padding-top: 100px;
    margin-bottom: 40px;
    text-align: center;

}

.shopping-cart .block-heading p{
  text-align: center;
  max-width: 420px;
  margin: auto;
  opacity:0.7;
}

.shopping-cart .dark .block-heading p{
  opacity:0.8;
}

.shopping-cart .block-heading h1,
.shopping-cart .block-heading h2,
.shopping-cart .block-heading h3{
  margin-bottom:1.2rem;
  /*color: #3b99e0;*/
  color: #622FAD;
}

.shopping-cart .items{
  margin: auto;
}

.shopping-cart .items .product{
  margin-bottom: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left:0;
}

.shopping-cart .items .product .info{
  padding-top: 0px;
  text-align: center;
}

.shopping-cart .items .product .info .product-name{
  font-size: 14px;
  font-weight: 600;
  color: #622FAD;
  padding-bottom: 10px;
}

h6{
  padding-left: 12px
}

.shopping-cart .items .product .info .product-name .product-info{
  font-size: 14px;
  margin-top: 15px;
  color: rgb(0 0 0 / 70%)
}

.shopping-cart .items .product .info .product-name .product-info .value{
  font-weight: 400;
}

.shopping-cart .items .product .info .quantity .quantity-input{
    margin: auto;
    width: 80px;
}

.shopping-cart .items .product .info .price{
    /*margin-top: 15px;*/
    font-weight: bold;
    /*font-size: 22px;*/
    font-size: 18px;
    text-align: left;
 }

.shopping-cart .summary{
  /*border-top: 2px solid #5ea4f3;*/
    background-color: #f7fbff;
    height: 100%;
    padding: 60px;
}

.shopping-cart .summary h3{
  text-align: center;
  font-size: 1.3em;
  font-weight: 600;
  padding-top: 20px;
  padding-bottom: 20px;
}

.shopping-cart .summary .summary-item:not(:last-of-type){
  padding-bottom: 10px;
  padding-top: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.shopping-cart .summary .summary-item{
  padding-bottom: 10px;
  padding-top: 10px;
}

.shopping-cart .summary .text{
  font-size: 1em;
  font-weight: 600;
}

.shopping-cart .summary .price{
  font-size: 1em;
  float: right;
}

.shopping-cart .summary button{
  margin-top: 20px;
}

@media (min-width: 768px) {
  .shopping-cart .items .product {
    padding-left: 50px;
  }

  .shopping-cart .items .product .info {
    padding-top: 55px;
    text-align: left;
  }

  .shopping-cart .items .product .info .price {
    font-weight: bold;
    /*font-size: 22px;*/
    font-size: 18px;
    top: 17px;
  }

  .shopping-cart .items .product .info .quantity {
    text-align: center;
  }
  .shopping-cart .items .product .info .quantity .quantity-input {
    padding: 4px 10px;
    text-align: center;
  }
}

/*************************************/

.payment_success_divider {
  position: relative;
  border-top: 1px solid rgb(0 0 0 / 10%);
}

.payment_success_body {
  /*font-size: 16px;*/
  font-size: 18px;
  line-height: 26px;
  /*text-transform: uppercase;*/
  margin-top: 0;
  margin-bottom: 15px;
  color: rgb(0 0 0 / 90%);
  /*color: #929090*/
}

.paid-detail {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  line-height: 30px;
  font-weight: 400;
  color: rgb(0 0 0);
}

.cust-detail {
  font-size: 1em;
  font-weight: 800;
  margin-right: 10px;
}

@media (max-width: 425px) {
  .cust-detail{
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/subscription-change-confirmation/subscription-change-confirmation.component.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,sBAAsB;AACxB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB;gFAC8E;EAC9E,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;;AAEtB;;;;;;;;;;;;;;;;;;;;;EAqBE;;AAEF,qCAAqC;AACrC;;;EAGE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAG3B,wBAAwB;AAC1B;AACA;;EAEE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,YAAY;EAEZ,+BAA+B;EAE/B,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,YAAY;EAEZ,4BAA4B;EAE5B,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB;8EAC4E;EAC5E,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;;AAEf,gBAAgB;AAChB;AACA,qBAAqB;AACrB,eAAe;AACf,mBAAmB;AACnB,iBAAiB;;AAEjB;;AAEA;AACA,qBAAqB;AACrB,eAAe;AACf,mBAAmB;AACnB,iBAAiB;;AAEjB;;AAEA,eAAe;AAYf;EACE;IAEE,uBAAuB;EACzB;EACA;IAEE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;;AAGA,6CAA6C;;AAE7C;EACE,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;CACnB;;AAED;EACE,iCAAiC;IAC/B,yBAAyB;IACzB,YAAY;IACZ,aAAa;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,sCAAsC;;AAEtC;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["/* Variables */\n* {\n  box-sizing: border-box;\n}\n\n/* body {\n  font-family: -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 16px;\n  -webkit-font-smoothing: antialiased;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  height: 100vh;\n  width: 100vw;\n} */\n\nform {\n  width: 30vw;\n  min-width: 500px;\n  align-self: center;\n  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\n    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\n  border-radius: 5px;\n  padding: 40px;\n}\n\n.hidden {\n  display: none;\n}\n\n#payment-message {\n  color: rgb(149, 40, 0);\n  font-size: 16px;\n  line-height: 20px;\n  padding-top: 12px;\n  text-align: center;\n}\n\n#payment-element {\n  margin-bottom: 24px;\n}\n\n/* Buttons and links */\n\n/*button {\n  background: #6e5eff;\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  color: #ffffff;\n  border-radius: 5px;\n  border: 0;\n  padding: 12px 16px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  display: block;\n  transition: all 0.2s ease;\n  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);\n  width: 100%;\n}\nbutton:hover {\n  filter: contrast(115%);\n}\nbutton:disabled {\n  opacity: 0.5;\n  cursor: default;\n}*/\n\n/* spinner/processing state, errors */\n.spinner,\n.spinner:before,\n.spinner:after {\n  border-radius: 50%;\n}\n.spinner {\n  color: #ffffff;\n  font-size: 22px;\n  text-indent: -99999px;\n  margin: 0px auto;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  box-shadow: inset 0 0 0 2px;\n  -webkit-transform: translateZ(0);\n  -ms-transform: translateZ(0);\n  transform: translateZ(0);\n}\n.spinner:before,\n.spinner:after {\n  position: absolute;\n  content: \"\";\n}\n.spinner:before {\n  width: 10.4px;\n  height: 20.4px;\n  background: #5469d4;\n  border-radius: 20.4px 0 0 20.4px;\n  top: -0.2px;\n  left: -0.2px;\n  -webkit-transform-origin: 10.4px 10.2px;\n  transform-origin: 10.4px 10.2px;\n  -webkit-animation: loading 2s infinite ease 1.5s;\n  animation: loading 2s infinite ease 1.5s;\n}\n.spinner:after {\n  width: 10.4px;\n  height: 10.2px;\n  background: #5469d4;\n  border-radius: 0 10.2px 10.2px 0;\n  top: -0.1px;\n  left: 10.2px;\n  -webkit-transform-origin: 0px 10.2px;\n  transform-origin: 0px 10.2px;\n  -webkit-animation: loading 2s infinite ease;\n  animation: loading 2s infinite ease;\n}\n\n/*WC 05132022 */\n.payment-sec {\n  display: flex;\n  margin-top: 5px;\n  justify-content: center;\n  align-items: center;\n}\n\n.selected-plan-sec {\n  display: flex;\n  margin-top: 5px;\n  justify-content: center;\n  align-items: center;\n}\n\n.selected-plan {\n  /*display: flex;*/\n  margin-top: 100px;\n  width: 30vw;\n  min-width: 500px;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\n  0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\n  border-radius: 5px;\n  padding: 40px;\n  font-size: 15px;\n  font-weight: 500;\n  /*background-color: #6e5eff;*/\n  background-color: #f7fbff;\n  color: rgb(0 0 0 / 70%);\n}\n\n.selected-plan-sec .selected-plan p {\n  text-align: center;\n  font-weight: 500;\n}\n\n/*WC 05132022 */\n\n/* WC 07202022 */\n.modal-body p{\ndisplay: inline-block;\nfont-size: 14px;\nfont-weight: normal;\nmargin-left: 10px;\n\n}\n\n.modal-body ul{\ndisplay: inline-block;\nfont-size: 14px;\nfont-weight: normal;\nmargin-left: 10px;\n\n}\n\n/* WC 07202022*/\n\n@-webkit-keyframes loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  form {\n    width: 80vw;\n    min-width: initial;\n  }\n}\n\n\n/********************************************/\n\n.shopping-cart{\n  padding-bottom: 50px;\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\n}\n\n.shopping-cart.dark{\n  background-color: #f6f6f6;\n}\n\n.shopping-cart .content{\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.075);\n  background-color: white;\n}\n\n.shopping-cart .block-heading{\n    /*padding-top: 50px;*/\n    padding-top: 100px;\n    margin-bottom: 40px;\n    text-align: center;\n\n}\n\n.shopping-cart .block-heading p{\n  text-align: center;\n  max-width: 420px;\n  margin: auto;\n  opacity:0.7;\n}\n\n.shopping-cart .dark .block-heading p{\n  opacity:0.8;\n}\n\n.shopping-cart .block-heading h1,\n.shopping-cart .block-heading h2,\n.shopping-cart .block-heading h3{\n  margin-bottom:1.2rem;\n  /*color: #3b99e0;*/\n  color: #622FAD;\n}\n\n.shopping-cart .items{\n  margin: auto;\n}\n\n.shopping-cart .items .product{\n  margin-bottom: 20px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-left:0;\n}\n\n.shopping-cart .items .product .info{\n  padding-top: 0px;\n  text-align: center;\n}\n\n.shopping-cart .items .product .info .product-name{\n  font-size: 14px;\n  font-weight: 600;\n  color: #622FAD;\n  padding-bottom: 10px;\n}\n\nh6{\n  padding-left: 12px\n}\n\n.shopping-cart .items .product .info .product-name .product-info{\n  font-size: 14px;\n  margin-top: 15px;\n  color: rgb(0 0 0 / 70%)\n}\n\n.shopping-cart .items .product .info .product-name .product-info .value{\n  font-weight: 400;\n}\n\n.shopping-cart .items .product .info .quantity .quantity-input{\n    margin: auto;\n    width: 80px;\n}\n\n.shopping-cart .items .product .info .price{\n    /*margin-top: 15px;*/\n    font-weight: bold;\n    /*font-size: 22px;*/\n    font-size: 18px;\n    text-align: left;\n }\n\n.shopping-cart .summary{\n  /*border-top: 2px solid #5ea4f3;*/\n    background-color: #f7fbff;\n    height: 100%;\n    padding: 60px;\n}\n\n.shopping-cart .summary h3{\n  text-align: center;\n  font-size: 1.3em;\n  font-weight: 600;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.shopping-cart .summary .summary-item:not(:last-of-type){\n  padding-bottom: 10px;\n  padding-top: 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.shopping-cart .summary .summary-item{\n  padding-bottom: 10px;\n  padding-top: 10px;\n}\n\n.shopping-cart .summary .text{\n  font-size: 1em;\n  font-weight: 600;\n}\n\n.shopping-cart .summary .price{\n  font-size: 1em;\n  float: right;\n}\n\n.shopping-cart .summary button{\n  margin-top: 20px;\n}\n\n@media (min-width: 768px) {\n  .shopping-cart .items .product {\n    padding-left: 50px;\n  }\n\n  .shopping-cart .items .product .info {\n    padding-top: 55px;\n    text-align: left;\n  }\n\n  .shopping-cart .items .product .info .price {\n    font-weight: bold;\n    /*font-size: 22px;*/\n    font-size: 18px;\n    top: 17px;\n  }\n\n  .shopping-cart .items .product .info .quantity {\n    text-align: center;\n  }\n  .shopping-cart .items .product .info .quantity .quantity-input {\n    padding: 4px 10px;\n    text-align: center;\n  }\n}\n\n/*************************************/\n\n.payment_success_divider {\n  position: relative;\n  border-top: 1px solid rgb(0 0 0 / 10%);\n}\n\n.payment_success_body {\n  /*font-size: 16px;*/\n  font-size: 18px;\n  line-height: 26px;\n  /*text-transform: uppercase;*/\n  margin-top: 0;\n  margin-bottom: 15px;\n  color: rgb(0 0 0 / 90%);\n  /*color: #929090*/\n}\n\n.paid-detail {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  line-height: 30px;\n  font-weight: 400;\n  color: rgb(0 0 0);\n}\n\n.cust-detail {\n  font-size: 1em;\n  font-weight: 800;\n  margin-right: 10px;\n}\n\n@media (max-width: 425px) {\n  .cust-detail{\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
